import 'reflect-metadata'
import { define, type, auto, Record, Collection } from 'type-r'
import { openDB, deleteDB } from 'idb';

import Store from './store.js'

import BlepharoplastyForm from '#forms/blepharoplasty.js'

@define
export default class BlepharoplastyFormStore extends Store {
    @(type(BlepharoplastyForm).events({"change": "formchange"}).as) blepharoplastyForm: BlepharoplastyForm
}

const store = window.store = new BlepharoplastyFormStore({ id: "blepharoplasty" })
export { store };
